"use strict";

function sortByDesignation(_ref) {
  var designation = _ref.designation;

  switch (true) {
    case /small/.test(designation):
      return 0;

    case /large/.test(designation):
      return 1;

    case /letterpress/.test(designation):
      return 2;

    case /envelope/.test(designation):
      return 3;

    default:
      return 99;
  }
}

exports.sortByDesignation = sortByDesignation;